import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { ToolsBoxService } from '../../Services/tools.service';

@Component({
    selector: 'error',
    templateUrl: 'error.component.html',
    imports: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorComponent implements OnInit {

    errorMessage: string;

    constructor(private toolsBoxService: ToolsBoxService, private route: ActivatedRoute,
    private router: Router) { }

    ngOnInit() {
        this.toolsBoxService.changeHeaderName("Error");
        const subResult = this.route.params.subscribe(params => {
                this.errorMessage  = params['errMessage'];
        });
    }

    ngAfterViewInit() {
        this.toolsBoxService.changeHeaderName("An error occured");
    }

}
